import { km } from '../../helpers/km';

type EventParams = {
  labelsCount: number;
};
export const aviaHistoryLabelsShow = (params: EventParams): void =>
  km({ name: 'avia_history_labels_show', params });
